import React from 'react';
import MissionApplicationForm from './MissionApplicationForm';
import './EventApplication.css';

interface EventApplicationProps {
  eventType?: string;
  eventId?: string;
}

const EventApplication: React.FC<EventApplicationProps> = ({ 
  eventType, 
  eventId = 'default-event-id' // This should be passed from the parent component
}) => {
  return (
    <div className="container mx-auto p-6 bg-white shadow-md rounded-lg">
      <MissionApplicationForm 
        eventId={eventId}
        eventTitle={eventType ? `Application — ${eventType}` : 'Application for OBP Italy 2026'}
      />
    </div>
  );
};

export default EventApplication;
